import { apiFetch } from "@/integrations/backend/client";

export type ContactSubmission = {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  subject: string | null;
  message: string;
  created_at: string | null;
};

export async function createContactSubmission(input: {
  name: string;
  email: string;
  phone?: string | null;
  subject?: string | null;
  message: string;
}): Promise<void> {
  const res = await apiFetch("/api/v1/contact-submissions/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`contact_failed:${res.status}`);
}

export async function listContactSubmissions(): Promise<ContactSubmission[]> {
  const res = await apiFetch("/api/v1/admin/contact-submissions", { method: "GET" });
  if (!res.ok) throw new Error(`contact_submissions_list_failed:${res.status}`);
  return (await res.json()) as ContactSubmission[];
}


